import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { boolean } from "yup";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Fetch } from "../../../shared/Fetch";

interface IProps {
    open: boolean,
    toast: any,
    singleData: any,
    hideDialog: () => void;
}

export const TenderClientAddedPOC = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const DateFormat = loginObj.date_Format;
    const onHide = () => {
        setTableData({ tableData: [], loading: false });
        props.hideDialog();
    };

    const loadTenderclient = async () => {
        try {
            setTableData((prev: any) => ({ ...prev, loading: true }));

            const response = await Fetch("Tender_POC_Mast", "GET", null, `vendorID=${props.singleData?.vendor_Company_ID}`, props.toast);

            if (response?.ok) {
                const data = await response.json();
                setTableData({ tableData: data, loading: false });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setTableData((prev) => ({ ...prev, loading: false }));
        }
    };

    useEffect(() => {
        if (props.open) loadTenderclient();
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: "80vw" }} header="Added POC's" modal className="p-fluid" onHide={onHide}>
            <DataTable value={tableData.tableData} loading={tableData.loading} showGridlines stripedRows header="">
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="contact_Name" header="Contact Name" />
                <Column field="contact_Email" header="Contact Email" />
                <Column field="contact_Phone" header="Contact Phone" />
                <Column field="contact_Mobile" header="Contact Mobile" />
                <Column field="department" header="Department" />
                <Column field="designation_Name" header="Designation" />
                <Column field="added_By" header="Added By" />
                <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
            </DataTable>
        </Dialog>
    );
}